<router-outlet></router-outlet>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.85)"></ngx-spinner>
<ng-snotify></ng-snotify>
